import React, { useEffect, useState } from 'react';
import Slider from "react-slick";

import MobileNavBar from "components/MobileNavBar/MobileNavBar";
import FollowingNavButton from "../components/FollowingNavButton/FollowingNavButton";
import VerticalNavButton from "../components/VerticalNavButton/VerticalNavButton";

import ProfileCard from "../components/ProfileCard/ProfileCard";
import ProfileCardSkeleton from "../components/ProfileCard/ProfileCardSkeleton";
import ArticlePreview from "../components/ArticlePreview/ArticlePreview";
import ArticlePreviewSkeleton from "../components/ArticlePreview/ArticlePreviewSkeleton";
import PublicationPreview from "../components/PublicationPreview/PublicationPreview";
import PublicationPreviewSkeleton from "../components/PublicationPreview/PublicationPreviewSkeleton";
import ContentButton from "../components/ContentButton/ContentButton";
import Skeleton from "../components/Skeleton/Skeleton";

import CopyLink from "../components/CopyLink/CopyLink";
import data_collaborators from "../content/collaborators.json";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// How to run:
// cd -L "path"
// npm start

function debounce(func, wait) {
    let timeout;
    let stackTraceTimeout;
    return function (...args) {
        if (timeout == null) {
            timeout = window.setTimeout(() => {
                timeout = null;
            }, wait);
            stackTraceTimeout = setTimeout(() => {
                func.apply(this, args);
                stackTraceTimeout = null;
            });
        } else if (stackTraceTimeout == null) {
            clearTimeout(timeout);
            timeout = window.setTimeout(() => {
                func.apply(this, args);
                timeout = null;
            }, wait);
        }
    };
}
// https://yeony-list.tistory.com/6


/* function useRefFocusEffect(onFocusCallback, deps) {
    const ref = useRef(null);
  
    useEffect(() => {
        if (ref.current) {
            const observer = new IntersectionObserver((entries) => entries.forEach((entry) => entry.isIntersecting && onFocusCallback()), {
                threshold: 1,
            });
            observer.observe(ref.current);
            return () => {
                if (ref.current) observer.unobserve(ref.current);
            };
        }
    }, [deps]);
  
    return { elementRef: ref };

    // 본문에서 사용법
    // const { elementRef } = useRefFocusEffect(fetch, [data]);
    // <div ref={elementRef}>이 요소가 보이면 fetch</div>
}*/

const PageHome = () => {
    const [data_news, set_data_news] = useState([]);
    const [data_publications, set_data_publications] = useState([]);
    const [data_people, set_data_people] = useState({members: [], alumni: []});
    const [data_carousel, set_data_carousel] = useState([]);
    useEffect(() => {
        // 스크롤하면 강조되는 내비게이션 설정
        let sections = Array.from(document.getElementsByTagName("section"));
        let nav_buttons = Array.from(document.getElementsByClassName("following-nav-button")); // 동적생성으로 바꿀까?

        var elements_above = new Set();
        let getLastValue = (set) => Array.from(set)[set.size - 1];

        function highlight_nav_buttons() {
            nav_buttons.forEach(nav_button => {
                let section_id = nav_button.querySelector('.label').getAttribute('href').replace('#', '');
                let section = sections.find(e => e.id === section_id);

                if (section.offsetTop - 20 <= window.scrollY) { // give som padding 
                    elements_above.add(nav_button);
                } else {
                    elements_above.delete(nav_button);
                }
            });
            nav_buttons.forEach(nav_button => {
                nav_button.setAttribute("highlight", "false");
            });
            if (elements_above.size >= 1) {
                getLastValue(elements_above).setAttribute("highlight", "true");
            } else {
                nav_buttons[0].setAttribute("highlight", "true");
            }
        }

        let event_scroll = debounce(highlight_nav_buttons, 10);
        window.addEventListener("scroll", event_scroll);
        highlight_nav_buttons();

        // Google Sheet 정보 가져오기 (News, Publications, People)
        (() => {
            fetch('/api/sheet-data?source=home')
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // console.log(data);
                set_data_news(data.news);
                set_data_publications(data.publications);
                set_data_people({
                    members: data.members,
                    alumni: data.alumni
                });
                set_data_carousel(data.carousel);
            })
            .catch((error) => console.error("Fetching error: ", error));
        })();

        return () => {
            window.removeEventListener("scroll", event_scroll);
        };
    }, []);

    const slider = React.useRef(null);

    const slider_settings = {
        dots: true,
        infinite: data_carousel.length > 1,
        speed: 500,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,

        swipe: true,           // 터치/스와이프 활성화 (기본값: true)
        swipeToSlide: false,    // 슬라이드당 스와이프 활성화
        touchMove: true,       // 터치 이동 활성화 (기본값: true)
        touchThreshold: 5,     // 스와이프 감도 (기본값: 5)
        draggable: true,
        accessibility: true,
        // 모바일 반응형 설정 추가
        // responsive: [
        //     {
        //         breakpoint: 768,
        //         settings: {
        //             swipe: true,
        //             swipeToSlide: true,
        //             touchMove: true,
        //             draggable: true
        //         }
        //     }
        // ],
        appendDots: dots => (
            <div>
                <button className="carousel-button" onClick={() => slider?.current?.slickPrev()}><span className="material-icons">chevron_left</span></button>
                <ul className="inline carousel-dots-container" > {dots} </ul>
                <button className="carousel-button" onClick={() => slider?.current?.slickNext()}><span className="material-icons">chevron_right</span></button>
            </div>
        ),
        beforeChange: (current, next) => {
            // 현재 활성 슬라이드에 "slick-current" 클래스가 적용되어 있음.
            const currentSlideIframe = document.querySelector('.slick-current iframe');
            if (currentSlideIframe) {
                currentSlideIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
            }
            const currentSlideItem = document.querySelector('.slick-current .carousel-item')
            if(currentSlideItem){
                currentSlideItem.blur()
            }
        },
    };

    return (
        <div className="flex flex-col items-center">
            <MobileNavBar>
                <VerticalNavButton label="Research" src="#content-research" />
                <VerticalNavButton label="Featured News" src="#content-news" />
                <VerticalNavButton label="Publication Highlights" src="#content-publication" />
                <VerticalNavButton label="People" src="#content-people" />
                <VerticalNavButton label="Open Positions" src="#content-open-positions" />
                <VerticalNavButton label="Related Links" src="#content-collaborators" />

            </MobileNavBar>

            <div className="main-image">
                <video autoPlay loop muted playsInline className='block md:hidden'>
                    <source src="./assets/main-mobile.mp4" type="video/mp4" />
                </video>
                <video autoPlay loop muted playsInline className='hidden md:block'>
                    <source src="./assets/main.mp4" type="video/mp4"/>
                </video>
            </div>
            <div className="content-horizontal-flex gap-11">
                <div id="desktop-nav-wrapper">
                    <div id="home-nav">
                        <FollowingNavButton label="Research" src="#content-research" />
                        <FollowingNavButton label="Featured News" src="#content-news" />
                        <FollowingNavButton label="Publication Highlights" src="#content-publication" />
                        <FollowingNavButton label="People" src="#content-people" />
                        <FollowingNavButton label="Achievements" src="#content-achievements" />
                        <FollowingNavButton label="Open Positions" src="#content-open-positions" />
                        <FollowingNavButton label="Related Links" src="#content-collaborators" />
                    </div>
                </div>

                <div id="content">
                    <div className="grouped-sections">
                        <section id="content-research">
                            <h2>Research</h2>
                            <div className="content-horizontal-flex gap-8">
                                <div className="w-full">
                                    <p >
                                        The Hyun Woo (Henry) Park lab is interested in understanding
                                        the plasticity of cancer cells during metastasis.
                                        We approach these questions by studying cancer metastasis,
                                        metabolism, signal transduction, and drug development.
                                        We utilize mouse models, tracing tumor cell lineages,
                                        multi-omics approaches, and advanced imaging techniques.
                                        We pioneered a novel concept in cell biology referred to
                                        as Adherent-to-Suspension Transition (AST). This innovative
                                        paradigm describes how cancer cells reprogram their anchorage
                                        dependency to enable transformation into circulating tumor cells
                                        (CTCs). Our goal is to develop next generation anti-metastatic
                                        therapies to significantly reduce cancer death rate.
                                    </p>
                                    <br />
                                    <h2>Research Projects</h2>
                                    <ul>
                                        <li>Adherent-to-Suspension Transition (AST) and metastasis</li>
                                        <li>Cancer metabolism and therapeutic responses</li>
                                        <li>Next generation anti-metastatic drug development</li>
                                        <li>Space biology and future therapeutics</li>
                                    </ul>
                                    <br /><br /><br />
                                </div>

                                <div className="professor-small">
                                    <img className="w-48 pb-2"
                                        alt="professor Hyun Woo Park"
                                        src="./assets/images/professor/Hyun Woo Park.png"
                                        draggable={false} />

                                    <div className="text-yonsei font-bold leading-normal">
                                        Hyun Woo (Henry) Park, PhD
                                    </div>
                                    <div>
                                        Professor<br />
                                        Dept. Biochemistry,<br />
                                        Yonsei University
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                                            <a href="https://x.com/_HyunWoo_PARK" target="_blank" rel="noopener noreferrer" draggable={false}>
                                                <img
                                                    src="./assets/images/professor/iconX.jpg"
                                                    alt="X 계정"
                                                    style={{ width: '40px', height: '40px' }}
                                                    draggable={false}
                                                />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        
                        {/* onTouchStart={(e) => {
                                    e.stopPropagation();
                                    console.log('start')
                                }}
                                onTouchEnd={(e) => {
                                    console.log(e.type)
                                    console.log('end')
                                    // if(e.type === TouchEvent.)
                                    e.stopPropagation();
                                }} */}
                        <section id="content-media">
                            <div className="carousel-container">
                                <Slider ref={slider} {...slider_settings}>
                                    {data_carousel.length === 0
                                        ? (
                                            <div className="carousel-item" data-index={0}>
                                                <Skeleton style={{ width: "100%", height: "100%" }} />
                                            </div>)
                                        : data_carousel.map((item, index) => {
                                                switch (item.type) {
                                                    case 'video': 
                                                        return (
                                                            <div className="carousel-item video-slide" data-index={index}>
                                                                <iframe src={item.src}
                                                                    title="YouTube video player"
                                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
                                                                <div className="pl-4 pt-4 pr-4">
                                                                    {item.title}
                                                                </div>
                                                            </div>);
                                                    case 'image':
                                                        return (
                                                            <div className="carousel-item" data-index={index}>
                                                                <img alt="About the content"
                                                                    src={item.src}
                                                                    draggable={false}/>
                                                                <div className="pl-4 pt-4 pr-4">
                                                                    {item.title}
                                                                </div>
                                                            </div>);
                                                    case 'image-link':
                                                        return (
                                                            <div className="carousel-item" data-index={index}>
                                                                <img alt="Link about the content"
                                                                    style={{ cursor: 'pointer' }}
                                                                    src={item.src}
                                                                    draggable={false}
                                                                    onClick={() => window.open(item.link, '_blank')}/>
                                                                <div className="pl-4 pt-4 pr-4">
                                                                    {item.title}
                                                                </div>
                                                            </div>);
                                                    default: return null;
                                                }})}
                                    {/* 
                                    <div className="carousel-item" data-index="6"
                                        onClick={() => window.open('./assets/pdfs/comic.pdf#page=8', '_blank')}>
                                        <img alt="people"
                                            // style={{ width: "100%", height: "100%", objectFit: "cover", border: "1px solid red" }}

                                            src="./assets/images/illustration_2.png" />
                                        <div className="pl-4 pt-4 pr-4">
                                            만화2 8페이졸
                                        </div>
                                    </div> */}
                                </Slider>
                                <br /><br />
                            </div>
                        </section>

                        <section id="content-news">
                            <h2>Featured News</h2>

                            <div className="list-articles">
                                {data_news.length === 0
                                    ? Array.from({ length: 3 }).map((_, index) => <ArticlePreviewSkeleton key={index} />)
                                    : data_news.filter(article => article.featured).map((article, index) => <ArticlePreview article={article} key={index}/>)}
                            </div>

                            <ContentButton label="View All Featured News" href="/news" />
                        </section>
                    </div>

                    <section id="content-publication">
                        <h2>Publication Highlights</h2>

                        <div className="list-publications">
                            {data_publications.length === 0
                                ? Array.from({ length: 3 }).map((_, index) => <PublicationPreviewSkeleton key={index} no_border={index === 0} />)
                                : data_publications.filter(article => article.featured).map((article, index) => <PublicationPreview article={article} no_border={index === 0} key={index}/>)}
                        </div>

                        <ContentButton label="View All Publications" href="/publications" />
                    </section>

                    <section id="content-people">
                        <h2>People</h2>

                        <div className="content-horizontal-flex gap-6 items-center">
                            <img className="size-48 max-w-[95%]"
                                alt="professor Hyun Woo Park"
                                src="./assets/images/professor/Hyun Woo Park 2.jpg"
                                draggable={false} />

                            <div>
                                <h2 className="text-text_black leading-none">Hyun Woo (Henry) PARK, Ph.D.</h2>
                                <div className="text-small italic leading-none -mt-[0.5em]">Professor, Translational Cancer Research Lab</div>
                                <ul className="mt-2 leading-[140%]">
                                    {/* <li>Cancer biologist Hyun Woo (Henry) Park investigates cancer cell plasticity in metastatic cascade and anti-metastatic drug development</li> */}
                                    <li>Board Member, Metastasis Research Society (MRS)</li>
                                    <li>Associate Dean, Office of Research Affairs</li>
                                    <li>Director, ARPA-H METAZERO Research Center</li>
                                    <li>Director, Yonsei Center for Research Facilities (YCRF)</li>
                                    <li>Director, Yonsei Global Research Security Center</li>
                                    <li>SUHF Fellow</li>
                                    {/* <li>University of California, San Diego: Postdoctoral Fellowship</li> */}
                                    {/* <li>Yonsei University: PhD</li> */}
                                </ul>
                            </div>
                        </div>

                        <br /><br />
                        <h3>Members</h3>

                        <div className="list-people">
                            {data_people.members.length === 0
                                ? Array.from({ length: 4 }).map((_, index) => <ProfileCardSkeleton key={index} />)
                                : data_people.members.map((person, index) => <ProfileCard person={person} key={index}/>)}
                        </div>

                        <br /><br />
                        <h3>Alumni</h3>

                        <div className="list-people">
                            {data_people.alumni.length === 0
                                ? Array.from({ length: 4 }).map((_, index) => <ProfileCardSkeleton key={index} />)
                                : data_people.alumni.map((person, index) => <ProfileCard person={person} key={index}/>)}
                        </div>
                    </section>

                    <section id="content-achievements">
                        <h2>Achievements</h2>
                        <ul>
                            <li>2026년 보건복지부 ARPA-H, METAZERO연구단 선정</li>
                            <li>2026년 국제암전이학회(MRS) 이사 선출</li>
                            <li>
                                2025년 에스오일 과학문화재단 차세대과학자상 수상
                                <span className="achievement-link-banner">
                                    <a href="https://biochem.yonsei.ac.kr/biochem/board/board03.do?mode=view&articleNo=460102&article.offset=0&articleLimit=10"
                                        target="_blank"
                                        rel="noreferrer"
                                        draggable={false}>
                                        [바로가기]
                                    </a>
                                </span>
                            </li>
                            <li>
                                2025년 첨단바이오 한-일-호주 글로벌 공동연구센터 지정
                                <span className="achievement-link-banner">
                                    <a href="https://biochem.yonsei.ac.kr/biochem/board/board03.do?mode=view&articleNo=218660"
                                        target="_blank"
                                        rel="noreferrer"
                                        draggable={false}>
                                        [바로가기]
                                    </a>
                                </span>
                            </li>
                            <li>

                                2024년 국가연구개발 우수성과 100선 선정
                                <span className="achievement-link-banner">
                                    <a href="https://www.kistep.re.kr/board.es?mid=a10202060400&bid=0072&act=view&list_no=93966"
                                        target="_blank"
                                        rel="noreferrer"
                                        draggable={false}>
                                        [바로가기]
                                    </a>
                                </span>
                            </li>
                            <li>
                                2024년 한국생화학분자생물학회 사석상 수상
                            </li>
                            <li>
                                2023년 미래융합전략센터 FSCS 융합연구 우수사례 선정
                            </li>
                            <li>
                                2023년 과학기술정보통신부 융합연구개발 활성화 유공자 장관 표창
                                <span className="achievement-link-banner">
                                    <a href="https://www.yonsei.ac.kr/_custom/yonsei/_app/ocx/news/app.jsp?mode=view&ar_seq=20240122132146253062&sr_volume=0&list_mode=list&sr_site=S&pager.offset=0&sr_cates=20160305000124325067"
                                        target="_blank"
                                        rel="noreferrer"
                                        draggable={false}>
                                        [바로가기]
                                    </a>
                                </span>
                            </li>
                            <li>
                                2020년 국가과학난제 AST암전이연구단 선정
                                <span className="achievement-link-banner">
                                    <a href="https://www.nscn.or.kr/?p=hrw"
                                        target="_blank"
                                        rel="noreferrer"
                                        draggable={false}>
                                        [바로가기]
                                    </a>
                                </span>
                            </li>
                            <li>
                                2019년 한국분자세포생물학회 신진과학자상 수상
                            </li>
                            <li>
                                2018년 서경배과학재단팰로우 선정
                                <span className="achievement-link-banner">
                                    <a href="https://www.suhf.org/investigator/people.do"
                                        target="_blank"
                                        rel="noreferrer"
                                        draggable={false}>
                                        [바로가기]
                                    </a>
                                </span>
                            </li>
                            <li>
                                2018년 포스코청암팰로우 선정
                            </li>


                        </ul>
                    </section>

                    <section id="content-open-positions">
                        <h2>Open Positions</h2>
                        <p>
                            Our lab warmly welcomes PhD Candidates and Postdoctoral Fellows with an interest to tackle grand challenges in cancer biology and drug development.
                        </p>
                        <CopyLink content="hwp003@yonsei.ac.kr" description="email">
                            <span className="material-icons">mail</span>&nbsp;hwp003@yonsei.ac.kr
                        </CopyLink>
                    </section>

                    {/* 너비가 제한되는 collaborators 섹션 */}
                    <section id="content-collaborators">
                        <h2>Related Links</h2>
                        <div className="collaborators-grid">
                            {/*data_collaborators.map((collaborator, index) => (
                                <div className={`collaborator-item ${index === 4 ? "large-image" : ""} ${index === 5 ? "small-image" : ""}`} key={index}>
                                    <a href={collaborator.href} target="_blank" rel="noopener noreferrer">
                                        <img
                                            src={collaborator.src}
                                            alt={collaborator.alt}
                                        />
                                    </a>
                                </div>
                            ))*/}
                            {data_collaborators.map((collaborator) => (
                                <a href={collaborator.src} target="_blank" rel="noopener noreferrer" key={collaborator.alt} draggable={false}>
                                    <img className="collaborator-item"
                                        src={collaborator.image_src}
                                        alt={collaborator.alt}
                                        draggable={false}
                                    />
                                </a>
                            ))}
                        </div>
                    </section>
                </div>

            </div>
        </div>);
};
export default PageHome;